import React from "react";


function Example({children}: any) {
  return (
    <div className="secondary || sticky_body || grey_header || inner_page">
      <header className="header" data-id="800">
        <div className="wrapper || wrapper_large">
          <div className="header_row">
              <a href="https://ezlife.dev4.xi-digital.com/" className="header_logo">
                  <img src="https://ezlife.dev4.xi-digital.com/img/logo.svg" className="logo" alt="EZ Life Insurance"></img>
              </a>
            <nav className="navigation">
              <ul className="header_nav">
                <li data-id="active_menu_1"><a href="https://ezlife.dev4.xi-digital.com/about-us">About</a></li>
                <li data-id="active_menu_2"><a href="https://ezlife.dev4.xi-digital.com/prices">Prices</a></li>
                <li data-id="active_menu_3"><a href="https://ezlife.dev4.xi-digital.com/faqs">FAQ</a></li>
                <li data-id="active_menu_4"><a href="https://ezlife.dev4.xi-digital.com/customer-support">Customer Support</a></li>
              </ul>
            </nav>
          </div>
        </div>
        
        <div className="navigation_btn">
          <div className="hamburger_box"></div>
        </div>
        <div className="dark_overlay"></div>
      </header>
      
      <div className="home_bar_space"></div>
      
      <section className="get_quote || sticky_content">
        <div className="wrapper || small_wrapper">
          {children}
        </div>
      </section>

      <footer>
        <div className="wrapper || wrapper_large">
          <div className="footer_row">
            <div className="footer_logo">
              <img src="https://ezlife.dev4.xi-digital.com/img/logo.svg" alt="EZ Life Insurance" />
            </div>
            
            <div className="footer_links">
              <nav className="footer_nav">
                <ul>
                  <li data-id="active_menu_1"><a href="https://ezlife.dev4.xi-digital.com/about-us">About</a></li>
                  <li data-id="active_menu_2"><a href="https://ezlife.dev4.xi-digital.com/prices">Prices</a></li>
                  <li data-id="active_menu_3"><a href="https://ezlife.dev4.xi-digital.com/faqs">FAQ</a></li>
                  <li data-id="active_menu_4"><a href="https://ezlife.dev4.xi-digital.com/customer-support">Customer Support</a></li>
                </ul>
              </nav>
            </div>
          </div>
      
          <div className="footer_bottom">
            <div className="wrapper || wrapper_large">
              <div className="footer_bottom_row">
                <div className="footer_bottom_text">
                  <p>Copyright © 2024 EZ LIFE INSURANCE.<br /> All Rights Reserved.</p>
                </div>
                <div className="footer_bottom_nav">
                  <ul>
                    <li><a href="https://ezlife.dev4.xi-digital.com/pages/privacy-policy">Privacy Policy</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <link rel="apple-touch-icon" sizes="180x180" href="https://ezlife.dev4.xi-digital.com/favicon/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="https://ezlife.dev4.xi-digital.com/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="https://ezlife.dev4.xi-digital.com/favicon/favicon-16x16.png" />

      <link rel="mask-icon" href="https://ezlife.dev4.xi-digital.com/favicon/safari-pinned-tab.svg" color="#6c8cc7" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="theme-color" content="#ffffff" />

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&amp;display=swap" rel="stylesheet" />

      <link rel="stylesheet" href="https://ezlife.dev4.xi-digital.com/css/libs.css?v1712578690" />
      <link rel="stylesheet" href="https://ezlife.dev4.xi-digital.com/css/main.css?v1727895399" />
    </div>
  )
}

export default Example;
